// CTA Section Component
// =====================
// Feature #287: Elegant design with design-line accents

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';
import DesignLine from '../ui/DesignLine';

const CTASection: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <section className="relative py-20 md:py-28 bg-neutral-dark dark:bg-gray-950 overflow-hidden">
      {/* Feature #287: Design-line accent at top of section */}
      <DesignLine variant="horizontal" className="absolute top-0 left-0 right-0" height={2} />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Feature #287: Subtle decorative elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-design-line-blue/5 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-design-line-orange/5 rounded-full blur-3xl" />
        </div>

        {/* Content */}
        <div className="relative">
          {/* Icon - Feature #287: Refined styling */}
          <div className="w-16 h-16 mx-auto mb-8 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center">
            <span className="text-3xl">🚀</span>
          </div>

          {/* Heading - Feature #280: Serif display font */}
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-4">
            {t('cta.title')}
          </h2>

          {/* Feature #287: Design-line accent under heading */}
          <div className="flex justify-center mb-8">
            <DesignLine variant="horizontal" width="100px" height={2} />
          </div>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl mx-auto font-sans">
            {t('cta.subtitle')}
          </p>

          {/* CTA Button - Feature #287: Elegant styling */}
          <Link to="/register">
            <Button
              variant="accent"
              size="lg"
              className="shadow-lg hover:shadow-xl transition-shadow"
            >
              {t('cta.button')}
            </Button>
          </Link>

          {/* Trust badge */}
          <p className="mt-6 text-sm text-gray-400 font-sans">
            {t('cta.trust')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
